import { styled, Box, StyleSystemProps } from '@withjoy/joykit';

export const StyledPage = styled(Box)``;

const pageStyles: StyleSystemProps = {
  width: '100%',
};

export const styles = {
  page: pageStyles,
};
